/**
 * When the device sends its queue by itself (URS-EXE-015 "automatic resynchronization"). Pure so it can be
 * tested: OfflineProvider calls it from an effect. Sending needs all of: a reachable server, a signed-in
 * person (the server will not take a queue from an unauthenticated device, N6), an unlocked store, and
 * something to do - queued entries, no trusted time anchor yet, or no copy of the batches yet.
 */
import type { EngineState } from "./engine.js";

export function shouldAutoSync(
  s: EngineState | null,
  online: boolean,
  signedInUserId: string | null,
): boolean {
  if (!s || !online || !signedInUserId || s.vault !== "UNLOCKED") return false;
  if (s.phase === "DEVICE_LOST") return false; // engine.sync() itself ignores a call while one is running
  const waiting = s.queue.some((c) => c.state === "QUEUED");
  return waiting || s.anchor === null || s.workingSet === null;
}
